import { BP_MOBILE, BP_TABLET, BP_DESKTOP, BP_WIDE } from "./_global-variables";
import { Splide } from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
  var elms = document.getElementsByClassName('splide');

  const configs = {
    default: {
      perPage: 3,
      breakpoints: {
        [BP_TABLET]: { perPage: 2, gap: '12px' },
        [BP_MOBILE]: { perPage: 1 },
      },
    },
    logos: {
      perPage: 5,
      breakpoints: {
        [BP_WIDE]: { perPage: 4 },
        [BP_TABLET]: { perPage: 3, gap: '12px' },
        [BP_MOBILE]: { perPage: 2 },
      },
    },
    compactevents: {
      perPage: 5,
      breakpoints: {
        [BP_WIDE]: { perPage: 4 },
        [BP_TABLET]: { perPage: 3, gap: '12px' },
        [BP_MOBILE]: { perPage: 2 },
      },
    },
  };

  for (var i = 0; i < elms.length; i++) {
    (function(elm) {
      const configType = elm.dataset.splideConfig || 'default';
      const perPageAttr = elm.dataset.perPage;

      // Base config from the type
      const baseConfig = configs[configType] || configs.default;

      // Merge perPage override if provided
      const mergedConfig = {
        ...baseConfig,
        ...(perPageAttr && {
          perPage: parseInt(perPageAttr, 10),
          breakpoints: undefined, // remove breakpoints if manually overriding perPage
        }),
      };

      // Common settings you want on all sliders
      const sharedSettings = {
        pagination: false,
        gap: '24px',
        arrowPath: 'M38.375 21.5184L39.8929 20.0006L38.375 18.4827L24.6607 4.76841L23.1429 3.25055L20.1161 6.27734L21.6339 7.79519L31.6875 17.8577H2.14286H0V22.1434H2.14286H31.6875L21.625 32.197L20.1071 33.7148L23.1339 36.7416L24.6518 35.2238L38.375 21.5184Z',
        lazyLoad: 'nearby',
      };

      // Final options object
      const options = {
        ...sharedSettings,
        ...mergedConfig,
      };

      var splide = new Splide(elm, options);

      var bar = elm.querySelector('.splide-progress-bar');
      if (bar) {
        splide.on('mounted move', function () {
          var end = splide.Components.Controller.getEnd() + 1;
          var rate = Math.min((splide.index + 1) / end, 1);
          bar.style.width = String(100 * rate) + '%';
        });
      }

      splide.mount();
    })(elms[i]);
  }
});

